<div>
  <div class="mx-auto mt-3 p-6 bg-card shadow-xl rounded-2xl border border-gray-100" *ngIf="showPreassement">
    <!-- Header -->
    <div class="text-center mb-6">
      <h2 class="text-4xl font-semibold text-primary">Pre-Appointment Health Assessment</h2>
      <p class="text-gray-500 mt-2">
        Help us understand your health condition before your consultation.
      </p>
    </div>

    <!-- Info Cards -->
    <div class="grid md:grid-cols-2 gap-6">
      <div class="p-4 bg-blue-50 rounded-xl">
        <h3 class="font-semibold text-blue-700 mb-2">🩺 What is this assessment?</h3>
        <p class="text-gray-600 text-sm">
          A short medical questionnaire to understand your symptoms, medical history, and current
          concerns.
        </p>
      </div>

      <div class="p-4 bg-green-50 rounded-xl">
        <h3 class="font-semibold text-green-700 mb-2">🎯 Why is it important?</h3>
        <p class="text-gray-600 text-sm">
          It helps the doctor prepare in advance and provide faster, more accurate consultation.
        </p>
      </div>

      <div class="p-4 bg-purple-50 rounded-xl">
        <h3 class="font-semibold text-purple-700 mb-2">⏱ Duration</h3>
        <p class="text-gray-600 text-sm">Takes only 3-5 minutes to complete.</p>
      </div>

      <div class="p-4 bg-orange-50 rounded-xl">
        <h3 class="font-semibold text-orange-700 mb-2">🔒 Privacy</h3>
        <p class="text-gray-600 text-sm">
          Your information is secure and shared only with your doctor.
        </p>
      </div>
    </div>

    <!-- Accept Section -->
    <div class="mt-8 flex items-center justify-between border-t pt-6">
      <p-button
        type="button"
        label="Start Assessment"
        icon="pi pi-arrow-right"
        class="p-button-lg"
        (click)="startAssessment()"
      >
      </p-button>
    </div>
  </div>
</div>

<patient-pre-assesment
  *ngIf="this.showPreAssesmentQue"

></patient-pre-assesment>
